import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import type { Location, NavigateFunction } from 'react-router-dom'
import { useNavigate, useParams } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import * as PlaylistShareActions from '@disco/state-management/actions/PlaylistShareActions'
import { deleteShortlist } from '@disco/state-management/actions/shortlist-upload-actions'
import * as ShortlistActions from '@disco/state-management/actions/ShortlistActions'
import { getLocationBeforeTransitions } from '@disco/state-management/selectors/routing'
import { getPlaylistSharesWithContacts } from '@disco/state-management/selectors/shares'
import { getShortlistById } from '@disco/state-management/selectors/shortlists'

import type { Shortlist } from 'types/shortlist'

import { getShortlistBaseRoute } from 'utils/routing'

import DocumentHeadTags from 'components/document-head-tags'
import SendPlaylistConfirmation from 'components/modals/playlist/send'

function mapStateToProps(state, { params }) {
  return {
    shortlist: getShortlistById(state, {
      id: params.shortlistId,
    }),
    shares: getPlaylistSharesWithContacts(state),
    user: state.user,
    location: getLocationBeforeTransitions(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      { ...ShortlistActions, ...PlaylistShareActions, deleteShortlist },
      dispatch,
    ),
    dispatch,
  }
}

type PlaylistShare = Record<string, any>
type Props = {
  location: Location
  shortlist: Shortlist
  dispatch: (..._args: Array<any>) => any
  shares: Record<string, PlaylistShare>
  params: {
    shortlistId: string
    shareId: string
  }
  deleteShortlist: typeof deleteShortlist
  navigate: NavigateFunction
}

class ShortlistShared extends React.Component<Props> {
  checkParams(props, params) {
    // check if params are valid to prevent futher errors and state corruption
    const { shortlist } = props
    const share = props.shares[params.shareId]

    if (!shortlist || !shortlist.playlist || !share) {
      return this.props.navigate('/')
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    this.checkParams(nextProps, this.props.params)
  }

  _closeModal = () => {
    const { shortlist } = this.props
    this.props.deleteShortlist(shortlist.id)
    this.props.navigate('/')
  }
  _shareAgain = () => {
    const { shortlistId } = this.props.params
    const baseRoute = getShortlistBaseRoute(this.props.location)
    const path = `${baseRoute}/shortlists/${shortlistId}/share`
    this.props.navigate(path)
  }

  render() {
    const { shortlistId, shareId } = this.props.params
    const { shortlist } = this.props
    const share = this.props.shares[shareId]
    if (!shortlist || !shortlist.playlist || !share) return null
    const { recipients } = share
    return (
      <div>
        <DocumentHeadTags title="Playlist sent | DISCO" />
        <SendPlaylistConfirmation
          {...this.props}
          recipients={recipients}
          newEmailGroupRoute={(() => {
            const baseRoute = getShortlistBaseRoute(this.props.location)
            return `${baseRoute}/shortlists/${shortlistId}/shared/${shareId}/create-email-group`
          })()}
          onClose={this._closeModal}
          onShareAgain={this._shareAgain}
        />
      </div>
    )
  }
}

const ConnectedShortlistShared = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShortlistShared)

function ShortlistSharedWithNavigation(props: any) {
  const navigate = useNavigate()
  const params = useParams<{ shortlistId: string; shareId: string }>()
  return (
    <ConnectedShortlistShared {...props} navigate={navigate} params={params} />
  )
}

export default ShortlistSharedWithNavigation as any
